import React from "react";
import { fetchInstitutions } from "../services/options_service";
import { asField } from 'informed';
import { components } from 'react-select';
import InputAsync from "./InputAsync";


const DropdownIndicator = (props) => {
  return components.DropdownIndicator && (
    <components.DropdownIndicator {...props}>
      <span style={{
        color: 'rgba(0, 0, 0, 0.6)',
        paddingBottom: '1rem',
      }}>
        ▼
      </span>
    </components.DropdownIndicator>
  );
};

export default asField(({
  fieldApi, onChange, fieldState, className, label, ...props
}) => (
  <InputAsync
    className={fieldState.error ? 'input-error red' : 'dropdown-style'}
    classNamePrefix="dropdown"
    value={fieldState.value || ''}
    error={fieldState.error}
    onChange={(value) => {
      fieldApi.setError(null);
      fieldApi.setValue(value);
      if (onChange) {
        onChange(value);
      }
    }}
    placeholder="Instituição do Ensino Médio"
    loadOptions={search => fetchInstitutions({ search, page_size: 10 })}
    styles={{
      control: (baseStyles, state) => ({ ...baseStyles, border: 'none' }),
      indicatorSeparator: (baseStyles, state) => ({ ...baseStyles, display: 'none' }),
      container: (baseStyles, state) => ({ ...baseStyles, backgroundColor: 'red' }),
    }}
    components={{ DropdownIndicator }}
    defaultOptions
    {...props}
  />
));
